import { Space, Row, Col } from "antd";
import { ClaimRankingConfigCard } from "./components/ClaimRankingConfigCard";
import { ClaimRankingPreviewCard } from "./components/ClaimRankingPreviewCard";

export const ClaimsRankingConfig = () => {
  return (
    <Row gutter={24}>
      <Col xs={24} lg={14}>
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          <ClaimRankingConfigCard />
        </Space>
      </Col>

      <Col xs={24} lg={10}>
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          <ClaimRankingPreviewCard />
        </Space>
      </Col>
    </Row>
  );
};
